/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from "react";
import Transactions from "../components/Transactions/Transactions";
import MyAssets from "../components/MyAssets";
import { useActiveAccount } from "thirdweb/react";
const Accounts = () => {
  const activeAccount = useActiveAccount();
  const [Default, setDefault] = useState("Red");
  const [apiData, setApiData] = useState([]);
  // useEffect(()=>{
  //   if(Default == "Red"){
  //     getRedTrasactions().then((res)=>{
  //       // console.log(res?.data,"ressss")
  //       setApiData(res?.data)
  //     }).catch((err)=>{
  //       console.log(err,"errrr")
  //     })
  //   }
  //   else if( Default == "Solos"){
  //     getSrTrasactions().then((res)=>{
  //       // console.log(res?.data,"ressss")
  //       setApiData(res?.data)
  //     }).catch((err)=>{
  //       console.log(err,"errrr")
  //     })
  //   }
  //   else{
  //     console.log("boq apiii")
  //   }

  // },[Default])

  return (
    <>
      <div className="ps-4">
        <div className="dashboard-centerd">
          <div className="row g-0">
            <div className="col-xl-8 col-xxl-9 pe-4 pt-4 border-end center-height">
              {/* <div className="row mb-5">
                <div className="col-12">
                  <div className="d-flex align-items-center justify-content-between mb-1"> */}
              {/* <h6 className="fw-600 text-black">Transactions</h6> */}
              {/* <Link className="view-btn" to="/">
                      view all <BiChevronRight />
                    </Link> */}
              {/* </div>
                </div>
              
              </div> */}
              <div className="col-12">
                <Transactions data={Default} />
              </div>
            </div>
            <div className="col-xl-4 col-xxl-3">
              <div className="right-sidebar px-xl-3 pe-4 pt-lg-5">
                <MyAssets />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Accounts;
